<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
      <div>
        <h2 class="text-center text-3xl font-extrabold text-gray-900">
          Welcome
        </h2>
      </div>

             <div class="space-y-4">
               <div>
                 <label for="username" class="block text-sm font-medium text-gray-700">
                   Username
                 </label>
                 <input
                   id="username"
                   v-model="username"
                   type="text"
                   required
                   class="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                   placeholder="Enter your username"
                 />
               </div>

               <button
                 @click="handleSSOLogin"
                 :disabled="loading || !username.trim()"
                 class="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
               >
                 <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                   <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6z" />
                 </svg>
                 {{ loading ? 'Authenticating...' : 'Login with Duo' }}
               </button>
             </div>

      <div v-if="error" class="rounded-md bg-red-50 p-4">
        <p class="text-sm text-red-800">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '../services/authService.js'

export default {
  name: 'DuoSSOLogin',
  emits: ['login-success'],
  data() {
    return {
      username: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async handleSSOLogin() {
      this.loading = true
      this.error = ''

      try {
        const result = await authService.getSSOUrl(this.username)
        if (result.success) {
          window.location.href = result.url
        } else {
          this.error = result.message
        }
      } catch (error) {
        this.error = 'Failed to initiate login. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
